import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { categorizeAndSortFeatures } from './amenities-selection/categorize-and-sort-features';
import { FeatureKey } from '@gql';

// UI
import { Typography } from '@components/typography';
import { Button } from '@components/button';
import { Icon, IconNames } from '@components/icon';
export type Feature = {
  key: FeatureKey;
  displayName: string;
  categoryName: string;
  promoted: boolean;
};
type Props = {
  allFeatures: Feature[];
  currentActiveFeatures: Feature[];
  toggleFeatureFilter: (featureFilter: Feature) => void;
};
export const AmenitiesSelection: React.FC<Props> = t0 => {
  const $ = _c(20);
  const {
    allFeatures,
    currentActiveFeatures,
    toggleFeatureFilter
  } = t0;
  const [showAllEnabled, setShowAllEnabled] = React.useState(false);
  let t1;
  if ($[0] !== allFeatures || $[1] !== currentActiveFeatures || $[2] !== showAllEnabled || $[3] !== toggleFeatureFilter) {
    let t2;
    if ($[5] !== currentActiveFeatures || $[6] !== showAllEnabled || $[7] !== toggleFeatureFilter) {
      t2 = (category, index) => {
        if (!showAllEnabled) {
          if (category.label !== "Popular") {
            return false;
          }
        }
        return <div key={index} className="my-2">{showAllEnabled && <Typography variant="subtitle2" variantM="subtitle1" component="h4" className="mb-2 mt-4 !tracking-normal text-primary-light">{category.label}</Typography>}<div className="mt-3 grid grid-cols-1 gap-x-8 lg:grid-cols-2 lg:gap-x-12">{category.features.map((feature, index_0) => {
              if (!showAllEnabled) {
                if (index_0 > 16) {
                  return false;
                }
              }
              return <div key={index_0}><label htmlFor={feature.displayName} className="flex items-center justify-between py-2 text-primary-main hover:cursor-pointer border-b border-gray-100 last:border-b-0"><span className="font-medium text-sm">{feature.displayName}</span><input id={feature.displayName} type="checkbox" className="flex-shrink-0 h-[18px] w-[18px] rounded border-[1.5px] border-primary-main accent-primary-main transition duration-150 ease-in-out cursor-pointer" onChange={() => toggleFeatureFilter(feature)} checked={currentActiveFeatures.includes(feature)} /></label></div>;
            })}</div></div>;
      };
      $[5] = currentActiveFeatures;
      $[6] = showAllEnabled;
      $[7] = toggleFeatureFilter;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = categorizeAndSortFeatures(allFeatures).map(t2);
    $[0] = allFeatures;
    $[1] = currentActiveFeatures;
    $[2] = showAllEnabled;
    $[3] = toggleFeatureFilter;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== showAllEnabled) {
    t2 = () => setShowAllEnabled(!showAllEnabled);
    $[9] = showAllEnabled;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = !showAllEnabled ? IconNames.CHEVRON_DOWN : IconNames.CHEVRON_UP;
  let t4;
  if ($[11] !== t3) {
    t4 = <Icon className="pr-2" name={t3} />;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = !showAllEnabled ? "see more" : "see less";
  let t6;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="flex flex-row justify-center"><Button variant="text" size="md" onClick={t2} className="hover:text-secondary-dark">{t4}{t5}</Button></div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <div>{t1}{t6}</div>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};